import { mediaQuery } from './media-query';

jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '565',
      () => {
        // Mobile do anything
        console.log('');
        carruselServicios();
      }
    );
  
});
jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '992',
      () => {
        // Mobile do anything
        carruselPromociones();
      }
    );
  
});

carruselMasonry();
listadoPlusGallery();
carruselOlivaNovaBeach();

function carruselMasonry() {
    /** General */
    jQuery('.col-galerias .custom-masonry >.elementor-container').owlCarousel({
        center: false,
        mouseDrag: true,
        touchDrag: true,
        loop: false,
        autoplay: false,
        dots: false,
        nav: true,
        navText: ["<i class='chevron-prev'></i>", "<i class='chevron-next'></i>"],
        responsive: {
            0: {
                items: 1,
                margin: 0
            },
            768: {
                items: 2,
                margin: 0,
            }
        }
    });
}
/** Function para destruir el carousel enm mobile y volverlo a construir para que se ajuste al diseño */
function carruselPromociones() {
    let owl = jQuery('.section-promociones-home .carrusel-promociones .owl-carousel');
    owl.owlCarousel('destroy');

    owl.owlCarousel({
        center: false,
        mouseDrag: true,
        touchDrag: true,
        loop: true,
        autoplay: false,
        dots: false,
        nav: true,
        responsive: {
            0: {
                items: 1.20,
                margin: 8
            },
            768: {
                items: 2.30,
                margin: 10
            }
        }
    });
}
function listadoPlusGallery() {
    let item = jQuery('.section-lideres .the7-simple-widget-posts .wf-cell');
    let listado = jQuery('.section-lideres .col-listado .dt-css-grid');
    
    //Add class active to first item
    item.first().find('.post-content-wrapper').addClass('active');
    
    const imageCarousel = jQuery ( '.section-lideres .swiper-container' );
    //Add class active when clicking on item in list
    item.on('click', function(){
        let index = jQuery(this).parent().children().index(this);
        jQuery(this).siblings().find('.post-content-wrapper').removeClass('active');
        jQuery(this).find('.post-content-wrapper').addClass('active');  
        //Swiper instance
        let swiperInstance = imageCarousel.data( 'swiper' );
        swiperInstance.slideTo( index );      
    });
    jQuery('.elementor-swiper-button-next').on('click', function(){
        let url = jQuery('.swiper-slide-next').data('swiper-slide-index');
        let indexListado = jQuery('.section-lideres .col-listado .dt-css-grid > .wf-cell').eq(url);
        indexListado.siblings().find('.post-content-wrapper').removeClass('active');
        indexListado.find('.post-content-wrapper').addClass('active');
    })
    jQuery('.elementor-swiper-button-prev').on('click', function(){
        let urlPrev = jQuery('.swiper-slide-prev').data('swiper-slide-index');
        let indexListadoPrev = jQuery('.section-lideres .col-listado .dt-css-grid > .wf-cell').eq(urlPrev);
        indexListadoPrev.siblings().find('.post-content-wrapper').removeClass('active');
        indexListadoPrev.find('.post-content-wrapper').addClass('active');
    })
    jQuery('.section-lideres .the7-simple-widget-posts .wf-cell .the7-simple-post-thumb a').on('click',e => {e.preventDefault();});
    jQuery('.section-lideres .the7-simple-widget-posts .wf-cell .post-entry-content a.post-title').on('click',e => {e.preventDefault();});


}
function carruselOlivaNovaBeach() {
    let owl = jQuery('.section-descubre-olivanova .col-carousel .carrusel-descubre');

    owl.owlCarousel({
        center: false,
        mouseDrag: true,
        touchDrag: true,
        loop: true,
        autoplay: false,
        dots: false,
        nav: true,
        navText: ["<i class='chevron-prev'></i>", "<i class='chevron-next'></i>"],
        responsive: {
            0: {
                items: 1.50,
                margin: 29
            },
            768: {
                items: 2.50,
                margin: 32
            },
            1024: {
                items: 3,
                margin: 44
            }
        }
    });
}


function carruselServicios() {
    jQuery('.section-servicios .elementor-container').addClass('owl-carousel');
    let owl = jQuery('.section-servicios .elementor-container');

    owl.owlCarousel({
        center: false,
        mouseDrag: true,
        touchDrag: true,
        loop: true,
        autoplay: false,
        dots: false,
        nav: true,
        navText: ["<i class='chevron-prev'></i>", "<i class='chevron-next'></i>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            }
        }
    });
}
